
import { ImportReport, PImportReport, useImportReports } from '@invivodf/common/src/contexts/parameters'
import { defineComponent, onBeforeMount, ref } from 'vue'
import { useRouter } from '@invivodf/common/src/application/composables/useRouter'

export default defineComponent({
  name: 'VImportReport',
  components: { PImportReport },
  setup() {
    const importReport = ref<ImportReport | null>(null)
    const error = ref(false)

    const router = useRouter()

    const reportId = Number(router.currentRoute.params.importId)
    const reportType = router.currentRoute.params.importType

    const fetchReport = async () => {
      try {
        const { fetchOne } = useImportReports()
        importReport.value = await fetchOne(reportType, reportId)
      } catch {
        error.value = true
      }
    }

    onBeforeMount(fetchReport)

    return { importReport, error }
  },
})
